import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Link, useNavigate } from "react-router-dom";
import { helperService, IDogPortrait } from "../../services/helper.service";
import { PasswordResetRequestDto } from "@eagerdog/interfaces";
import { Helmet } from "react-helmet";

import "../../styles/Signup.scss";

import logo from "../../assets/logo.svg";
import emailIcon from "../../assets/icons/email.svg";

import Input from "../../components/Input/Input";
import { toast } from "../../components/Toast/ToastManager";
import { apiService } from "../../services";

interface IProps {}

const ResetPassword: React.FC<IProps> = (props) => {
  const navigate = useNavigate();

  let [email, setEmail] = useState<string>("");
  
  useEffect(() => {
    if (helperService.isLoggedIn()) {
      navigate("/");
    }
  });

  const sendCode = () => {
    let payload:PasswordResetRequestDto = {
      email: email,      
    };

    apiService.passwordResetRequest(payload).then((response: any) => {      
      toast.show({
        title: "Reset Password",
        content: "A password reset link has been sent to your email. Use it to set a password and claim your account if you don't have one yet.",
        duration: 10000,
        type: "success"
      });
    }).catch((error:any) => {
      toast.show({
        title: "Reset Password",
        content: error?.response?.data?.message || "Something went wrong, please try again later",
        duration: 10000,
        type: "fail"
      });
    });
  }

  return (
    <div className="Login Signup">
    <Helmet>
      <title>Reset Password</title>
      <meta name="robots" content="noindex, nofollow" />
    </Helmet>
      <div className="images">
        <div className="logo"><Link to="/"><img src={logo} alt="Eager Dog" /></Link></div>
        <motion.div initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{ delay: 0.2 }} className="dogCards">
          <div className="cardRow">
            {helperService.topDogs.map((dog:IDogPortrait, i:number) => {
              return(
                <div key={i} className="dogCard">
                  <div className="dogPortrait">
                    <img src={dog.image} alt={"Dog Portrait of " + dog.name} />
                  </div>
                  <span>{dog.name}</span>
                </div>
              );
            })}
          </div>
          <div className="cardRow">
            {helperService.bottomDogs.map((dog:IDogPortrait, i:number) => {
              return(
                <div key={i} className="dogCard">
                  <div className="dogPortrait">
                    <img src={dog.image} alt={"Dog Portrait of " + dog.name} />
                  </div>
                  <span>{dog.name}</span>
                </div>
              );
            })}
          </div>
        </motion.div>
        <motion.div initial={{ opacity: 0, translateY: "-300px" }} whileInView={{ opacity: 1, translateY: "-50px" }} transition={{ delay: 0.5 }} className="dogBanner">
          <motion.div initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{ delay: 1 }} className="bannerInner">
            <div className="small">The Best Place</div>
            <div className="large">for your <span>Dog</span></div>
            <div className="dogWrap">
              <div className="portrait"><img src={helperService.allDogs[2].image} alt={"Dog Portrait of " + helperService.allDogs[2].name} /></div>
            </div>
            <div className="dogName">Stan</div>
          </motion.div>
        </motion.div>
      </div>
      <div className="content">
        <div className="inner">
          <div className="logo"><img src={logo} alt="Eager Dog" /></div>
          <div className="reset-title">
            <h1>Reset Password</h1>
            <div>Enter the email linked to your Eager Dog account, We'll send a link to reset your password.</div>
          </div>                    
          <div className="form">
            <form onSubmit={(e) => { e.preventDefault(); sendCode(); }}>
              <Input type="email" onChange={(e:any) => { setEmail(e.target.value); }} icon={emailIcon} label="Email" placeholder="Enter your email" />                            
              <div className="actions">
                <button type="submit">Send Code</button>
              </div>
              {/* <div className="register">I don't have access to my email anymore.</div> */}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
